<template>
  <div class="order-step">
    <next-prev-menu
      :disabled="false"
      :previous="true"
      title="Naar Controleren"
      @next-step="$router.push({ name: 'printProductSecuredSAConfirm' })"
      @prev-step="$router.push({ name: 'printProductSecuredSADeliver' })"
    ></next-prev-menu>
    <invoice
      :orderDetails="orderDetails"
      :shop="shop"
      @updateOrder="updateOrder"
      @updateProject="updateProject"
    ></invoice>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { usePrintProductSecuredSAStore } from '@/features/printProductSecuredSA/PrintProductSecuredSA.store'
import NextPrevMenu from '@/components/NextPrevMenu.vue'
import Invoice from '@/components/Invoice.vue'

export default {
  data() {
    return {}
  },
  components: {
    NextPrevMenu,
    Invoice
  },
  methods: {
    updateOrder(val) {
      this.printProductSecuredSAStore.updateOrderDetails(val[0], val[1])
    },
    updateProject(project) {
      this.printProductSecuredSAStore.updateProject({
        name: project.name || '',
        id: project.id || 0
      })
    }
  },
  computed: {
    ...mapStores(usePrintProductSecuredSAStore),
    custom() {
      return this.printProductSecuredSAStore.customFields
    },
    orderDetails() {
      return this.printProductSecuredSAStore.orderDetails
    },
    shop() {
      return this.printProductSecuredSAStore.shop
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped>
.card {
  // height: 590px;
}
</style>
